export default __webpack_public_path__ + "static/Plots0089-c63d00ce55c00fb78a68ce8a79b30780.jpg";